import React, { useContext, useRef } from 'react';
import classnames from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useOnOutsideClick } from '../../utils/hooks/useOnOutsideClick';
import s from './EmoteSelectorPopupWrapper.scss';
var EmoteSelectorPopupWrapper = React.forwardRef(function (_a, ref) {
    var buttonRect = _a.buttonRect, children = _a.children, contentClassname = _a.contentClassname, onClickOutside = _a.onClickOutside;
    var isMobile = useContext(MobileContext);
    var rootRef = useRef(null);
    useOnOutsideClick([rootRef], function () {
        onClickOutside && onClickOutside();
    }, true);
    if (window === undefined) {
        return null;
    }
    var styles;
    var arrowRight = false;
    var arrowSize = 10;
    var popupWidth = 328;
    var popupHeight = 342;
    var hideArrow = false;
    // position menu to the left of icon on mobile
    // or if there's not enough space and it would show offscreen
    if ((isMobile || buttonRect.left + popupWidth / 2 > window.innerWidth) &&
        buttonRect.left - popupWidth > 0) {
        styles = {
            top: buttonRect.top + window.scrollY + popupWidth / 2 + arrowSize / 2,
            left: buttonRect.left - popupWidth - arrowSize * 2,
        };
        arrowRight = true;
    }
    else {
        styles = {
            top: buttonRect.top + window.scrollY - arrowSize / 2,
            left: buttonRect.left - popupWidth / 2 + arrowSize / 2,
        };
    }
    // Make sure we are not off screen, if we are bring it back into the
    // screen area and hide the arrow
    if (styles.left < 0) {
        styles.left = 0;
        hideArrow = true;
    }
    if (styles.top - popupHeight < 0) {
        styles.top = popupHeight + 15;
        hideArrow = true;
    }
    styles.top = styles.top + "px";
    styles.left = styles.left + "px";
    return (React.createElement("div", { style: styles, className: classnames(s['wrapper'], s['top']), ref: ref },
        React.createElement("div", { className: s['container'] },
            React.createElement("div", { className: classnames(s['content'], contentClassname), ref: rootRef }, children),
            !hideArrow && (React.createElement("div", { className: classnames(s['arrow'], arrowRight && s['arrow-right']) })))));
});
EmoteSelectorPopupWrapper.displayName = 'EmoteSelectorPopupWrapper';
export default EmoteSelectorPopupWrapper;
//# sourceMappingURL=EmoteSelectorPopupWrapper.js.map